import { getMomentTz } from './getMomentTz'

export const getDayMonth = (date) => {
  const dateObject = getMomentTz(date)
  const day = dateObject.date()
  const month = dateObject.format('MMM')
  return {
    day,
    month,
  }
}
